module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution-two.4ae2ab4d.png";